import { useState } from 'react';
import { Button, ImageListItem, Typography } from '@mui/material';
import calendar from '../../assets/icons/calendar.svg';
import { useSelector } from 'react-redux';

const OfferLetter = (props) => {
  const styledCalandarIcon = {
    width: 80,
    display: 'inline-block',
    height: 60,
    position: 'relative',
    mt: 2,
  };

  const styledDayNumber = {
    position: 'absolute',
    color: '#52418a',
    fontWeight: '600',
    top: '50%',
    left: '51%',
    transform: 'translate(-50%, -50%)',
  };
  const months = [
    '',
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec',
  ];

  const { candidateStatus } = useSelector((state) => state?.candidateState);
  const [popupModal, setPopupModal] = useState({
    open: false,
    type: '',
  });
  const [joiningDay, joiningMonth, joiningYear] =
    candidateStatus && candidateStatus?.joining_date?.split('-');

  return (
    <>
      <Typography variant='body2'>
        Offer letter has been sent to your personal mail id.
      </Typography>
      <Typography variant='body2'>
        {` Your date of joining as ${candidateStatus?.designation}    is `}
      </Typography>
      {joiningDay ? (
        <div style={{ position: 'relative' }}>
          <ImageListItem component='div' sx={styledCalandarIcon}>
            <img alt='Calendar' src={calendar}></img>
          </ImageListItem>
          <Typography variant='h5' sx={styledDayNumber}>
            {joiningDay}
          </Typography>
          <Typography fontSize='1rem' color='primary'>
            {`${months[parseInt(joiningMonth)]} ${joiningYear}`}
          </Typography>
        </div>
      ) : (
        <Typography variant='body2' sx={{ my: 2 }}>
          {`We will inform your joining date shortly`}
        </Typography>
      )}
      {/* <Typography variant='body2' sx={{ my: 2 }}>
                Please accept it before{'-'}
                <b>{'-'}</b>.
            </Typography> */}
      <Button
        sx={{ m: 1, mt: '1.5rem' }}
        variant='contained'
        onClick={props?.onAccept}>
        Accept Offer
      </Button>
      <Button
        sx={{ m: 1, mt: '1.5rem' }}
        variant='outlined'
        onClick={props?.onReject}>
        Reject Offer
      </Button>
    </>
  );
};

export default OfferLetter;
